import { useContext } from 'react';

import { LaunchDarklyContext } from '@/context/LaunchDarklyProvider';

const useLaunchDarkly = () => {
  return useContext(LaunchDarklyContext);
};

export default useLaunchDarkly;
